import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.scss';

type Variant =
  | 'primary' | 'secondary' | 'ghost' | 'danger' | 'success'
  // Variantes TEINTÉES (texte + icône colorés, fond transparent) : pour les toolbars denses
  // où l'on veut différencier les actions par couleur sans multiplier les boutons pleins.
  | 'softPrimary' | 'softSuccess' | 'softWarning' | 'softDanger';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'secondary',
    size = 'md',
    leftIcon,
    rightIcon,
    loading,
    fullWidth,
    className,
    children,
    disabled,
    ...rest
  },
  ref,
) {
  const classes = [
    styles.button,
    styles[`variant_${variant}`],
    styles[`size_${size}`],
    fullWidth && styles.fullWidth,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button ref={ref} className={classes} disabled={disabled || loading} {...rest}>
      {loading ? <span className={styles.spinner} aria-hidden /> : leftIcon && <span className={styles.icon}>{leftIcon}</span>}
      <span className={styles.label}>{children}</span>
      {rightIcon && !loading && <span className={styles.icon}>{rightIcon}</span>}
    </button>
  );
});
